export default (context, inject) => {
  const setSessionCookie = () => {
    let sessionId = context.app.$cookies.get('session_id')

    if (!sessionId) {
      let randomString = ''
      const time = new Date().getTime()
      const chars =
        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

      for (let i = 10; i > 0; --i) {
        randomString += chars[Math.floor(Math.random() * chars.length)]
      }
      sessionId = time + randomString

      context.app.$cookies.set('session_id', sessionId, {
        maxAge: 60 * 60 * 24 * 30,
        path: '/'
      })
    }
    return sessionId
  }

  inject('setSessionCookie', setSessionCookie)
}
